const transitionStyles2 = {
  entering: {
    opacity: 0,
    transform: 'translateX(20px)',
  },
  entered: {
    opacity: 1,
    transform: 'translateX(0)',
    transition: 'opacity 500ms, transform 500ms',
  },
  exiting: {
    opacity: 1,
    transform: 'translateX(0)',
  },
  exited: {
    opacity: 0,
    transform: 'translateX(-20px)',
    transition: 'opacity 500ms, transform 500ms',
  },
};

export const transitionHandlers = {
  onEnter: (node: HTMLElement) => {
    Object.assign(node.style, transitionStyles2.entering);
  },
  onEntering: (node: HTMLElement) => {
    Object.assign(node.style, transitionStyles2.entered);
  },
  onExit: (node: HTMLElement) => {
    Object.assign(node.style, transitionStyles2.exiting);
  },
  onExiting: (node: HTMLElement) => {
    Object.assign(node.style, transitionStyles2.exited);
  },
};
